import axios from 'axios';


import store from '@/store/store';
import router from '@/router';
import localstorage from '@/helpers/localstorage';
import { USER_LOGOUT, START_TIMER } from '@/store/action_types';


export const httpSetup = () => {
    
    if (localstorage.getJwt()) {
        axios.defaults.headers.common['Authorization'] = localstorage.getJwt();
    }

    axios.interceptors.request.use(function(config) {
        config.headers.Authorization =  localstorage.getJwt();
        
        console.log('interceptor_req config:', config);

        return config;
    }, function (error) {
        console.log('interceptor_req err:', error);
        return Promise.reject(error);
    } 
    )

    axios.interceptors.response.use(function(config) {
        console.log('interceptor_res config:', config);

        if (config.data.token) {
            const token = config.data.token;
            localstorage.setJwt(token)
            store.dispatch({
                type: START_TIMER
            })
        }
        // if (config.data.meta.jwt_token) {
        //     const token = config.data.meta.jwt_token
        //     localstorage.setJwt(token);
        // }

        return config;
    }, function (error) {
        if (store.getters.getLoggedin) {
            if (error.response.status === 403 || error.response.status === 401) {
                store.dispatch(USER_LOGOUT);
                router.replace({
                    name: 'auth-error',
                    params: {
                        errorCode: error.response.status
                    }
                })
    
            }
        }

        

        console.log('interceptor_res err:', error);

        return Promise.reject(error);
    } 
    )

}